import React, { useState, useEffect } from "react";
import LeftSideNavigation from "../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import { Form, Row, Col, Image, Button } from "react-bootstrap";
import { TextField } from "@material-ui/core";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { FormControl, Select, InputLabel } from "@material-ui/core";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import axios from "axios";
import { serverApi } from "../../../../config/Keys";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { Referral_cashback_add } from "../../../../store/actions/SuperAdminActions/SuperAdminReferralCashbackAction";
import moment from "moment";
import {
  getAllCountries,
  getAllStateFromCountry,
  getAllCityFromState,
} from "../../../../store/actions/SuperAdminActions/adminCategoryAndIconsAction";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";

const validationSchema = yup.object({
  // referral_name: yup
  //   .string()
  //   .required("referral name is required")
  //   .max(64, "Maximum 64 Character"),
  description: yup.string().max(150, "Maximum 150 Character"),
  start_date: yup.string().required("Start date is required"),
  start_time: yup.string().required("Start time is required"),
  end_date: yup.string().required("End date is required"),
  end_time: yup.string().required("End time is required"),
  referral_activity_type: yup.number().required("select atleast one"),
  term_and_condition: yup
    .string()
    .required("Terms and condtion  is required")
    .min(1, "Minimum 1 Character")
    .max(512, "Maximum 512 Character"),
  // photos: yup.array().min(1),
});

function AddRefferalprogram(props) {
  let history = useHistory();
  const [ReferralType, setReferralType] = useState("0");

  const onSuccessAddOffer = () => {
    // setLoading(false);
    history.push("/SuperAdminReferralRewarddashboard");
  };
  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };
  // const [state, setState] = useState({
  //   referral_name: "",
  //   description: "",
  //   referrralType: 0,
  //   start_date: "",
  //   start_time: "",
  //   end_date: "",
  //   end_time: "",
  //   transactionType: "",
  //   referral_activity_type: 0,
  //   qualifying_option: [],
  //   referrer_amount: 5,
  //   referee_amount: 5,
  //   udbhav_amount: 5,
  //   term_and_condition: "",
  // });

  const formik = useFormik({
    initialValues: {
      programName: "",
      city: "",
      state: "",
      country: "",
      countryCode: "+91",
      description: "",
      referral_type: "UU",
      start_date: "",
      start_time: "",
      end_date: "",
      end_time: "",
      transactionType: 2,
      referral_activity_type: 1,
      qualifying_option: [],
      referrer_amount: "",
      referee_amount: "",
      udbhav_amount: "",
      term_and_condition: "",
    },
    validationSchema,
    onSubmit: (values) => {
      var formData = {};
      const startDate = {
        start_date: moment(
          values.start_date + "T" + values.start_time
        ).toISOString(),
      };

      const end_Date = {
        end_date: moment(values.end_date + "T" + values.end_time).toISOString(),
      };

      // var location = {
      //   latitude: "26.23568784466822",
      //   longitude: "78.15339087385253",
      // };
      if (
        values.referee_amount ||
        values.referrer_amount ||
        values.udbhav_amount
      ) {
        formData.programName = values.programName;
        formData.countryCode = values.countryCode;
        formData.country = values.country;
        formData.state = values.state;
        formData.city = values.city;
        formData.description = values.description;
        formData.referral_type = values.referral_type;
        formData.start_date = startDate.start_date;
        formData.end_date = end_Date.end_date;
        formData.transactionType = values.transactionType;
        formData.referral_activity_type = values.referral_activity_type;
        formData.qualifying_option = values.qualifying_option;
        formData.referrer_amount = values.referrer_amount;
        formData.referee_amount = values.referee_amount;
        formData.udbhav_amount = values.udbhav_amount;
        formData.term_and_condition = values.term_and_condition;
        // formData.active = active.active;
        // formData.isGlobal = true;

        // formData.mark_as_primary = primaryOffer.primaryOffer;
        // formData.send_to_carousel = "false";

        const onErrorAddOffer = () => {
          // setLoading(false);
        };
        const token = props.auth.user.accessToken;
        // setLoading(true);

        props.Referral_cashback_add(
          token,
          formData,
          onSuccessAddOffer

          // () => {
          //   Alert.success(`<h4>Successfully added</h4>`, {
          //     position: "top-right",
          //     effect: "bouncyflip",
          //     beep: true,
          //     html: true,
          //     timeout: 3000,
          //     offset: 35,
          //   });
          // },
          // () => {
          //   Alert.error(`<h4>Please check the fields.</h4>`, {
          //     position: "top-right",
          //     effect: "bouncyflip",
          //     beep: true,
          //     html: true,
          //     timeout: 3000,
          //     offset: 35,
          //   });
          // }
        );
      } else {
        formik.setErrors({
          referee_amount: "Any one of these are required.",
          referrer_amount: "Any one of these are required.",
          udbhav_amount: "Any one of these are required.",
        });
      }
    },
  });
  useEffect(() => {
    if (formik.errors && formik.errors.description) {
      let descElement = document.getElementById("description");
      descElement.focus();
    } else if (formik.errors && formik.errors.start_date) {
      let startDateElement = document.getElementById("start_date");
      startDateElement.focus();
    } else if (formik.errors && formik.errors.start_time) {
      let startTimeElement = document.getElementById("start_time");
      startTimeElement.focus();
    } else if (formik.errors && formik.errors.end_date) {
      let endDateElement = document.getElementById("end_date");
      endDateElement.focus();
    } else if (formik.errors && formik.errors.end_time) {
      let endTimeElement = document.getElementById("end_date");
      endTimeElement.focus();
    } else if (formik.errors && formik.errors.coupon_code) {
      let couponCodeElement = document.getElementById("coupon_code");
      couponCodeElement.focus();
    } else if (formik.errors && formik.errors.term_and_condition) {
      let termAndCondtionsElement =
        document.getElementById("term_and_condition");
      termAndCondtionsElement.focus();
    }
  }, [count]);
  // const onSubmit = async (e) => {
  //   e.preventDefault();
  //   let payload = {
  //     referral_name: state.referral_name,
  //     description: state.description,
  //     referrralType: state.referrralType,
  //     start_date: state.start_date + " " + state.start_time,
  //     end_date: state.end_date + " " + state.end_time,
  //     referral_activity_type: state.referral_activity_type,
  //     transactionType: state.transactionType,
  //     qualifying_option: [0, 1, 2, 3],
  //     referrer_amount: state.referrer_amount,
  //     referee_amount: state.referrer_amount,
  //     udbhav_amount: state.udbhav_amount,
  //     term_and_condition: state.term_and_condition,
  //   };
  //   const token = props.auth.user.accessToken;
  //   props.Referral_cashback_add(
  //     token,
  //     payload,
  //     () => {
  //       Alert.success(`<h4>Successfully added</h4>`, {
  //         position: "top-right",
  //         effect: "bouncyflip",
  //         beep: true,
  //         html: true,
  //         timeout: 3000,
  //         offset: 35,
  //       });
  //     },
  //     () => {
  //       Alert.error(`<h4>Please check the fields.</h4>`, {
  //         position: "top-right",
  //         effect: "bouncyflip",
  //         beep: true,
  //         html: true,
  //         timeout: 3000,
  //         offset: 35,
  //       });
  //     }
  //   );

  // };
  // const onChangeReferralType = (e) => {
  //   setReferralType(e.target.value);
  // };

  const handleQualifyOptions = (e) => {
    if (!formik.values.qualifying_option.includes(e.target.value)) {
      let arr = formik.values.qualifying_option;
      arr.push(e.target.value);
      formik.setFieldValue("qualifying_option", arr);
    } else {
      let arr = formik.values.qualifying_option.filter(function (item) {
        return item !== e.target.value;
      });
      formik.setFieldValue("qualifying_option", arr);
    }
  };

  const [show, setShow] = useState(true);
  const showTr = () => setShow(!show);
  const [minDate, setMinDate] = useState("");
  const [minEndDate, setMinEndDate] = useState("");

  const handleStartDateChange = (e) => {
    formik.setFieldValue("start_date", e.target.value);
    formik.setFieldValue("end_date", "");
    setMinEndDate(e.target.value);
  };

  useEffect(() => {
    let data = moment().format("YYYY-MM-DD");
    setMinDate(data);
  }, []);

  const [data, setData] = useState({ country: "", state: "", city: "" });

  const onChangeCountry = (e) => {
    props.getAllStateFromCountry(e.target.value, onSuccessGetAllStates);

    setData({
      [e.target.name]: e.target.value,
      state: "",
      city: "",
    });

    formik.setFieldValue("city", "");
    formik.setFieldValue("state", "");

    for (let i = 0; i < countries.length; i++) {
      if (e.target.value === countries[i].id) {
        formik.setFieldValue("country", countries[i].name);
        // formik1.setFieldValue("country_id", countries[i].id);
        break;
      }
    }
  };

  const onChangeState = (e) => {
    props.getAllCityFromState(e.target.value, onSuccessGetAllCity);
    setData({
      country: data.country,
      [e.target.name]: e.target.value,
      city: "",
    });

    formik.setFieldValue("city", "");
    //  formik.setFieldValue("city_id", "");
    for (let i = 0; i < states.length; i++) {
      if (e.target.value === states[i].id) {
        formik.setFieldValue("state", states[i].name);
        break;
      }
    }
  };

  const onChangeCity = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
    for (let i = 0; i < city.length; i++) {
      if (e.target.value === city[i].id) {
        formik.setFieldValue("city", city[i].name);
        break;
      }
    }
  };

  const [countries, setAllCountries] = useState([]);
  const [states, setAllStates] = useState([]);
  const [city, setAllCity] = useState([]);

  const onSuccessGetAllCountries = (allData) => {
    setAllCountries(allData);
    if (
      props &&
      props.auth &&
      props.auth.user &&
      props.auth.user.VendorUser.country
    ) {
      for (let i = 0; i < allData.length; i++) {
        if (props.auth.user.VendorUser.country === allData[i].iso2) {
          let e = {};
          e.target = {};
          e.target.value = allData[i].id;
          e.target.name = "country";
          onChangeCountry(e, "any");
          formik.setFieldValue("country", allData[i].name);
          //  formik.setFieldValue("countryCode", allData[i].id);

          break;
        }
      }
    }
  };

  const onSuccessGetAllStates = (data) => {
    setAllStates(data);
  };

  const onSuccessGetAllCity = (data) => {
    setAllCity(data);
  };

  useEffect(() => {
    props.getAllCountries(onSuccessGetAllCountries);
  }, []);

  let qualify_options = [];
  if (formik.values.transactionType === 2) {
    qualify_options = [
      { id: 0, value: 0, title: "Takeaway" },
      { id: 1, value: 1, title: "Curbside" },
      { id: 2, value: 2, title: "Skip The Line" },
      { id: 3, value: 3, title: "Dine-In" },
      { id: 4, value: 4, title: "Walkin" },
      { id: 5, value: 5, title: "Waitlist" },
      { id: 6, value: 6, title: "Reservation" },
      { id: 7, value: 7, title: "Home Delivery" },
      { id: 8, value: 8, title: "Ticket Booking" },
      { id: 9, value: 9, title: "Select All" },
    ];
  } else if (formik.values.transactionType === 1) {
    qualify_options = [
      { id: 4, value: 4, title: "Walkin" },
      { id: 5, value: 5, title: "Waitlist" },
      { id: 6, value: 6, title: "Reservation" },
    ];
  } else {
    qualify_options = [
      { id: 0, value: 0, title: "Takeaway" },
      { id: 1, value: 1, title: "Curbside" },
      { id: 2, value: 2, title: "Skip The Line" },
      { id: 3, value: 3, title: "Dine-In" },
      { id: 7, value: 7, title: "Home Delivery" },
      { id: 8, value: 8, title: "Ticket Booking" },
      { id: 9, value: 9, title: "Select All" },
    ];
  }

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="super-admin-inside-right-side-panel">
              <div className="d-flex justify-content-between align-items-center pt-4 pb-3">
                <div className="f24_700_HelveticaNeue">
                  Add Referral Program
                </div>
              </div>
              <hr />
              <Form>
                <Row className="pt-4">
                  <Col md={3}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-Country">
                          Country
                        </InputLabel>

                        <Select
                          value={data.country}
                          //value="101"
                          onChange={onChangeCountry}
                          label="country"
                          inputProps={{
                            name: "country",
                            id: "outlined-country",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {countries.map((country, index) => (
                            <option key={index} value={country.id}>
                              {country.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>

                      {formik.errors.country && formik.touched.country ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.country}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-state">State</InputLabel>
                        <Select
                          value={data.state}
                          onChange={onChangeState}
                          label="state"
                          inputProps={{
                            name: "state",
                            id: "outlined-state",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {states.map((state, index) => (
                            <option key={index} value={state.id}>
                              {state.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                      {formik.errors.state && formik.touched.state ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.state}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col md={3}>
                    <Form.Group>
                      <FormControl variant="outlined" className="w-100">
                        <InputLabel htmlFor="outlined-state">city</InputLabel>
                        <Select
                          value={data.city}
                          onChange={onChangeCity}
                          label="state"
                          inputProps={{
                            name: "city",
                            id: "outlined-state",
                          }}
                          IconComponent={KeyboardArrowDownIcon}
                        >
                          {city.map((city, index) => (
                            <option key={index} value={city.id}>
                              {city.name}
                            </option>
                          ))}
                        </Select>
                      </FormControl>
                      {formik.errors.city && formik.touched.city ? (
                        <div className="pho_14_regular text-danger">
                          {formik.errors.city}
                        </div>
                      ) : null}
                    </Form.Group>
                  </Col>
                  <Col lg={5} className="my-2">
                    <FormControl variant="outlined" fullWidth>
                      <InputLabel id="demo-simple-select-outlined-label">
                        Select Referral Program Category*
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-outlined-label"
                        id="demo-simple-select-outlined"
                        name="referral_type"
                        onChange={(e) =>
                          formik.setFieldValue("referral_type", e.target.value)
                        }
                        value={formik.values.referral_type}
                        label="referral_type"
                      >
                        <MenuItem
                          value="Referral Program Name"
                          disabled
                          selected
                        >
                          Select Referral Type
                        </MenuItem>
                        <MenuItem value="UU">user to user</MenuItem>
                        <MenuItem value="UV">user to merchant</MenuItem>
                        <MenuItem value="VU">merchant to user</MenuItem>
                        <MenuItem value="VV">
                          Marketing and promotion to User{" "}
                        </MenuItem>
                        <MenuItem value="AU">Sales rep to Merchant </MenuItem>
                        <MenuItem value="SV">Affiliate to User </MenuItem>
                        <MenuItem value="SU">Affiliates to Merchant </MenuItem>
                        <MenuItem value="PU">Partner to User </MenuItem>
                        <MenuItem value="MU">Partner to Merchant </MenuItem>
                      </Select>
                    </FormControl>
                  </Col>
                  <Col lg={8} className="my-2">
                    <Form.Group>
                      <TextField
                        // ref={nameee}
                        id="programName"
                        label="Referral Program Name"
                        type="text"
                        onChange={(e) =>
                          formik.setFieldValue("programName", e.target.value)
                        }
                        value={formik.values.programName}
                        variant="outlined"
                        className={`w-100 ${
                          formik.errors.programName &&
                          formik.touched.programName
                            ? "enError"
                            : ""
                        }`}
                        name="name"
                      />
                      {formik.errors.programName &&
                        formik.touched.programName && (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.programName}
                          </div>
                        )}
                    </Form.Group>
                    <Form.Group>
                      <TextField
                        // ref={description}
                        id="description"
                        label="Description"
                        type="text"
                        multiline
                        rows="5"
                        variant="outlined"
                        className={`w-100 `}
                        className={`w-100 ${
                          formik.errors.description &&
                          formik.touched.description
                            ? "enError"
                            : ""
                        }`}
                        onChange={(e) =>
                          formik.setFieldValue("description", e.target.value)
                        }
                        value={formik.values.description}
                      />
                      {formik.errors.description &&
                        formik.touched.description && (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.description}
                          </div>
                        )}
                    </Form.Group>
                    <Row className="pb-4">
                      <Col lg={6}>
                        <div className="f12-400" style={{ color: "#9E9E9E" }}>
                          *Max 150 characters
                        </div>
                      </Col>
                    </Row>
                    <Row></Row>
                  </Col>
                  <Col lg={12}>
                    <hr />
                    <div className="font_20_b py-4">
                      Referral Validity Details*
                    </div>
                    <Row className="pb-4 align-items-center">
                      <Col md={3} xl={2}>
                        <TextField
                          id="start_date"
                          // label="Start Date"
                          variant="outlined"
                          type="date"
                          disablePast
                          //minDate={new Date())}
                          onChange={(e) => handleStartDateChange(e)}
                          value={formik.values.start_date}
                          className={`w-100 ${
                            formik.errors.start_date &&
                            formik.touched.start_date
                              ? "enError"
                              : ""
                          }`}
                          name="start_date"
                        />
                        {formik.errors.start_date &&
                          formik.touched.start_date && (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.start_date}
                            </div>
                          )}
                      </Col>
                      <Col md={3} xl={2}>
                        <TextField
                          id="start_time"
                          // label="Start Time"
                          variant="outlined"
                          type="time"
                          className={`w-100 ${
                            formik.errors.start_time &&
                            formik.touched.start_time
                              ? "enError"
                              : ""
                          }`}
                          onChange={formik.handleChange}
                          value={formik.values.start_time}
                          name="start_time"
                        />
                        {formik.errors.start_time &&
                          formik.touched.start_time && (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.start_time}
                            </div>
                          )}
                      </Col>
                      <Col md={3} xl={2}>
                        <TextField
                          id="end_date"
                          variant="outlined"
                          type="date"
                          className={`w-100`}
                          onChange={formik.handleChange}
                          value={formik.values.end_date}
                          className={`w-100 ${
                            formik.errors.end_date && formik.touched.end_date
                              ? "enError"
                              : ""
                          }`}
                          name="end_date"
                        />
                        {formik.errors.end_date && formik.touched.end_date && (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.end_date}
                          </div>
                        )}
                      </Col>
                      <Col md={3} xl={2}>
                        <TextField
                          id="end_time"
                          variant="outlined"
                          type="time"
                          className={`w-100`}
                          onChange={formik.handleChange}
                          value={formik.values.end_time}
                          className={`w-100 ${
                            formik.errors.end_time && formik.touched.end_time
                              ? "enError"
                              : ""
                          }`}
                          name="end_time"
                        />
                        {formik.errors.end_time && formik.touched.end_time && (
                          <div className="pho_14_regular text-danger">
                            {formik.errors.end_time}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <hr />
                    <div className="font_20_b py-4">
                      Referral Activity Type*
                    </div>
                    <div className="row checkbox-bank-account justify-content-start mb-4">
                      <div className="col-4 col-sm-4 col-md-3">
                        <label className="enRadioWithText small">
                          <span className="f12-500">
                            With Qualifying Activity
                          </span>
                          <input
                            id="ActivityType"
                            type="radio"
                            name="ActivityType"
                            value={0}
                            onClick={(e) =>
                              formik.setFieldValue("referral_activity_type", 0)
                            }
                          
                          />
                          <span className="checkmark"></span>
                        </label>

                        <div>
                          <p className="f12-400 opacity5 pl-3">
                            Define the qualifying activity by selecting from the
                            options below, you can select one or more
                          </p>
                        </div>
                      </div>
                      <div className="col-4 col-sm-4 col-md-3">
                        <label className="enRadioWithText small">
                          <span className="f12-500">
                            With Registration Activity
                          </span>
                          <input
                            id="ActivityType"
                            type="radio"
                            name="ActivityType"
                            value={1}
                            onClick={(e) =>
                              formik.setFieldValue("referral_activity_type", 1)
                            }
                            defaultChecked
                          />
                          <span className="checkmark"></span>
                        </label>
                        {formik.values.referral_activity_type === 1 && (
                          <>
                            <div>
                              <p className="f12-400 opacity5 pl-3">
                                When user signs up with an OTP, the referral
                                activity will get qualified
                              </p>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    {formik.values.referral_activity_type === 0 && (
                      <>
                        <div className="font_20_b py-4">
                          Select Transaction Type*
                        </div>
                        <div className="row checkbox-bank-account justify-content-start mb-4">
                          <div className="col-4 col-sm-4 col-md-3">
                            <label className="enRadioWithText small">
                              <span className="f12-500">Paid Transactions</span>
                              <input
                                id="transactionType"
                                type="radio"
                                name="transactionType"
                                required
                                value={0}
                                onClick={(e) =>
                                  formik.setFieldValue("transactionType", 0)
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          </div>
                          <div className="col-4 col-sm-4 col-md-3">
                            <label className="enRadioWithText small">
                              <span className="f12-500">
                                Unpaid Transactions
                              </span>
                              <input
                                id="transactionType"
                                type="radio"
                                name="transactionType"
                                value={1}
                                onClick={(e) =>
                                  formik.setFieldValue("transactionType", 1)
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          </div>
                          <div className="col-4 col-sm-4 col-md-3">
                            <label className="enRadioWithText small">
                              <span className="f12-500">Both</span>
                              <input
                                id="transactionType"
                                type="radio"
                                name="transactionType"
                                defaultChecked
                                value={2}
                                onClick={(e) =>
                                  formik.setFieldValue("transactionType", 2)
                                }
                              />
                              <span className="checkmark"></span>
                            </label>
                          </div>
                        </div>{" "}
                        <br />
                        <div className="my-1 col-10">
                          <ul
                            type="none"
                            className={"enStatusList"}
                            style={{ justifyContent: "left" }}
                          >
                            {qualify_options.map((e) => (
                              <li
                                value={e.value}
                                className={`${
                                  formik.values?.qualifying_option.includes(
                                    e.value
                                  ) && `active`
                                }`}
                                onClick={handleQualifyOptions}
                                style={{ width: "20%", fontSize: "14px" }}
                              >
                                {e.title}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </>
                    )}
                    {formik.values.referral_activity_type === 0 && (
                      <>
                        <div className="pl-3">
                          <p className="font_20_b py-4">
                            Qualifying Activity: Complete Status
                          </p>
                          <p className="f12-400 opacity5 pl-4">
                            When referred user completes this step the referral
                            activity will get qualified and the money will be
                            disbursed to that respective user.
                          </p>
                        </div>
                      </>
                    )}
                    <hr />
                    <div className="font_20_b py-4">
                      <div className="font_20_b py-4">
                        Referral Amount Details*
                      </div>
                      <p className="f12-400 opacity5">
                        Define the amount for referral activity and Udbhav
                      </p>
                    </div>
                    <div className="ml-4">
                      <Col lg={8}>
                        <Row className="py-3">
                          <Col lg={4}>
                            <p className="f14-700">Referrer </p>
                          </Col>
                          <Col lg={4}>
                            <FormControl variant="outlined" fullWidth>
                              <InputLabel id="demo-simple-select-outlined-label">
                                Enter Amount
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-outlined-label"
                                error={formik.errors.referrer_amount}
                                id="demo-simple-select-outlined"
                                name="referralType"
                                onChange={(e) =>
                                  formik.setFieldValue(
                                    "referrer_amount",
                                    e.target.value
                                  )
                                }
                                value={formik.values.referrer_amount}
                                label="date_range"
                              >
                                <MenuItem value="">Enter Amount</MenuItem>
                                <MenuItem value="0">0</MenuItem>
                                <MenuItem value="5">5</MenuItem>
                                <MenuItem value="10">10</MenuItem>
                                <MenuItem value="30">30</MenuItem>
                                <MenuItem value="50">50</MenuItem>
                              </Select>
                            </FormControl>
                            {formik?.errors?.referrer_amount && (
                              <div className="f10-400 text-danger">
                                {formik.errors?.referrer_amount}
                              </div>
                            )}
                          </Col>
                        </Row>
                        <Row className="py-3">
                          <Col lg={4}>
                            <p className="f14-700">Referee </p>
                          </Col>
                          <Col lg={4}>
                            <FormControl variant="outlined" fullWidth>
                              <InputLabel id="demo-simple-select-outlined-label">
                                Enter Amount
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-outlined-label"
                                error={formik.errors.referee_amount}
                                id="demo-simple-select-outlined"
                                name="referralType"
                                onChange={(e) =>
                                  formik.setFieldValue(
                                    "referee_amount",
                                    e.target.value
                                  )
                                }
                                value={formik.values.referee_amount}
                                label="date_range"
                              >
                                <MenuItem value="">Enter Amount</MenuItem>
                                <MenuItem value="0">0</MenuItem>
                                <MenuItem value="5">5</MenuItem>
                                <MenuItem value="10">10</MenuItem>
                                <MenuItem value="30">30</MenuItem>
                                <MenuItem value="50">50</MenuItem>
                              </Select>
                            </FormControl>
                            {formik?.errors?.referee_amount && (
                              <div className="f10-400 text-danger">
                                {formik.errors?.referee_amount}
                              </div>
                            )}
                          </Col>
                        </Row>
                        <Row className="py-3">
                          <Col lg={4}>
                            <p className="f14-700">Udbhav</p>
                          </Col>
                          <Col lg={4}>
                            <FormControl variant="outlined" fullWidth>
                              <InputLabel id="demo-simple-select-outlined-label">
                                Enter Amount
                              </InputLabel>
                              <Select
                                labelId="demo-simple-select-outlined-label"
                                error={formik.errors.udbhav_amount}
                                id="demo-simple-select-outlined"
                                name="referralType"
                                onChange={(e) =>
                                  formik.setFieldValue(
                                    "udbhav_amount",
                                    e.target.value
                                  )
                                }
                                value={formik.values.udbhav_amount}
                                label="udbhav"
                              >
                                <MenuItem value="">Enter Amount</MenuItem>
                                <MenuItem value="0">0</MenuItem>
                                <MenuItem value="5">5</MenuItem>
                                <MenuItem value="10">10</MenuItem>
                                <MenuItem value="30">30</MenuItem>
                                <MenuItem value="50">50</MenuItem>
                              </Select>
                            </FormControl>
                            {formik?.errors?.udbhav_amount && (
                              <div className="f10-400 text-danger">
                                {formik.errors?.udbhav_amount}
                              </div>
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </div>
                    <Row>
                      <Col lg={8}>
                        <Form.Group>
                          <TextField
                            id="term_and_condition"
                            label="Terms and Conditions"
                            type="text"
                            multiline
                            rows="5"
                            variant="outlined"
                            className={`w-100 ${
                              formik.errors.term_and_condition &&
                              formik.touched.term_and_condition
                                ? "enError"
                                : ""
                            }`}
                            name="terms_and_condition"
                            onChange={(e) =>
                              formik.setFieldValue(
                                "term_and_condition",
                                e.target.value
                              )
                            }
                            value={formik.values.term_and_condition}
                          />
                          {formik.errors.term_and_condition &&
                            formik.touched.term_and_condition && (
                              <div className="pho_14_regular text-danger">
                                {formik.errors.term_and_condition}
                              </div>
                            )}
                        </Form.Group>
                        <div className="py-2 f12-400">
                          (Fill out the terms and conditions Referral Activity)
                        </div>
                      </Col>
                    </Row>
                    <div className="py-4 d-flex align-items-center">
                      <Button
                        variant="outline-secondary"
                        className="btn-lg mr-4 px-5 btn150px"
                        onClick={() => onSuccessAddOffer()}
                      >
                        Cancel
                      </Button>
                      <Button
                        variant="danger"
                        className="btn-lg px-5 btn150px"
                        //type="submit"
                        onClick={() => onClickSave()}
                      >
                        create
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}
// export default AddRefferalprogram;

AddRefferalprogram.propTypes = {
  auth: PropTypes.object.isRequired,
  Referral_cashback_add: PropTypes.func.isRequired,
  getAllCountries: PropTypes.func.isRequired,
  getAllStateFromCountry: PropTypes.func.isRequired,
  getAllCityFromState: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {
  Referral_cashback_add,
  getAllCountries,
  getAllStateFromCountry,
  getAllCityFromState,
})(AddRefferalprogram);
